import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  private configs$: Object = null;

  constructor(private http: HttpClient) { }

  public load() {
    return this.http.get('assets/env/env.json')
    .toPromise()
    .then(config => {
      this.configs$ = config;
    });
  }

  public getConfig(key: any) {
    return this.configs$[key];
  }
}
